module.exports = __webpack_public_path__ + "img/platform-activities-14-days-in-row.0cb8d7a4.png";